// extracted by mini-css-extract-plugin
module.exports = {"deliveryCartField":"DeliveryCartField_deliveryCartField__pe_JV","icon":"DeliveryCartField_icon__sPjP3","v2":"DeliveryCartField_v2__6ysy9"};